// src/redux/slices/userSlice.js - Legacy Redux implementation
import { getUserCredits } from '../../services/userApi';

// Action Types
const FETCH_USER_PLAN_REQUEST = 'user/FETCH_USER_PLAN_REQUEST';
const FETCH_USER_PLAN_SUCCESS = 'user/FETCH_USER_PLAN_SUCCESS';
const FETCH_USER_PLAN_FAILURE = 'user/FETCH_USER_PLAN_FAILURE';
const UPDATE_CREDITS = 'user/UPDATE_CREDITS';
const RESET_USER_STATE = 'user/RESET_USER_STATE';

// Action Creators
export const fetchUserPlanRequest = () => ({
  type: FETCH_USER_PLAN_REQUEST,
});

export const fetchUserPlanSuccess = (data) => ({
  type: FETCH_USER_PLAN_SUCCESS,
  payload: data,
});

export const fetchUserPlanFailure = (error) => ({
  type: FETCH_USER_PLAN_FAILURE,
  payload: error,
});

export const updateCredits = (credits) => ({
  type: UPDATE_CREDITS,
  payload: credits,
});

export const resetUserState = () => ({
  type: RESET_USER_STATE,
});

// Async Action Creator (Thunk)
export const fetchUserPlan = (user) => {
  return async (dispatch) => {
    dispatch(fetchUserPlanRequest());
    
    try {
      const data = await getUserCredits(user);
      dispatch(fetchUserPlanSuccess(data));
    } catch (error) {
      dispatch(fetchUserPlanFailure(error.toString()));
    }
  };
};

// Initial State
const initialState = {
  planType: null,
  credits: 0,
  daysLeft: 0,
  totalCreditsUsed: 0,
  createdAt: null,
  planStartDate: null,
  // Server-computed: how many text-edits per sketch the user is allowed in
  // the tech pack. 0 means "show paywall popup on edit".
  techPackSketchEditCap: 0,
  loading: 'idle', // 'idle' | 'pending' | 'succeeded' | 'failed'
  error: null,
};

// Reducer
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_PLAN_REQUEST:
      return {
        ...state,
        loading: 'pending',
        error: null,
      };
      
    case FETCH_USER_PLAN_SUCCESS:
      return {
        ...state,
        loading: 'succeeded',
        planType: action.payload.planType || 'free',
        credits: action.payload.credits || 0,
        daysLeft: action.payload.planDaysLeft || 0,
        totalCreditsUsed: action.payload.totalCreditsUsed || 0,
        createdAt: action.payload.createdAt || null,
        planStartDate: action.payload.planStartDate || null,
        techPackSketchEditCap: action.payload.techPackSketchEditCap ?? 0,
        error: null,
      };
      
    case FETCH_USER_PLAN_FAILURE:
      return {
        ...state,
        loading: 'failed',
        error: action.payload,
      };
      
    case UPDATE_CREDITS:
      return {
        ...state,
        credits: action.payload,
      };
      
    case RESET_USER_STATE:
      return initialState;
      
    default:
      return state;
  }
};

export default userReducer;